import {ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation} from '@angular/core';
import moment from 'moment';

import {ResidentStatisticsModel} from '../../models/resident.statistics.model';

@Component({
	selector: 'ic-resident-overview-card',
	templateUrl: './resident-overview.component.html',
	styleUrls: ['./resident-overview.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class ResidentOverviewComponent implements OnInit {
	private residentModel = inject(ResidentStatisticsModel);

	protected today = moment().format('DD/MM/YYYY');
	protected statistics$ = this.residentModel.statistics$;
	protected loading$ = this.residentModel.loading$;

	ngOnInit(): void {
		this.residentModel.loadStatistics();
	}
}
